import { AllowanceCharge } from '../../data/models'

export function isAcceptButtonDisabled(items: AllowanceCharge[]) {
  // if no items are selected return true
  if (!items?.length) {
    return true
  }

  // if the items are modified return true
  const isModified = items?.some(item => item.Status === 'MODIFIED')
  return isModified
}
